import React, { useId } from "react";

interface SwitchProps {
  checked: boolean;
  onChange?: (checked: boolean) => void;
  className?: string;
  children?: React.ReactNode;
  label?: string;
  isSetting?: boolean;
  disabled?: boolean;
}

export const Switch: React.FC<SwitchProps> = ({
  checked,
  onChange,
  className = "",
  children,
  label,
  isSetting = false,
  disabled = false,
}) => {
  const id = useId();

  const handleClick = () => {
    if (!disabled) {
      onChange?.(!checked);
    }
  };

  return (
    <label
      htmlFor={id}
      className={`flex flex-none items-center ${disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"} ${isSetting ? "flex-row-reverse w-full" : ""}`}
    >
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        aria-disabled={disabled}
        disabled={disabled}
        onClick={handleClick}
        id={id}
        className={`group/switch ${
          checked
            ? "bg-indigo-600 dark:bg-indigo-500"
            : "bg-slate-200 dark:bg-slate-800 "
        } relative flex-none inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 ring-offset-slate-800 ${disabled ? "cursor-not-allowed" : ""} ${className}`}
      >
        <span className="sr-only">Toggle</span>
        <span
          className={`${
            checked
              ? "translate-x-6 bg-slate-300 "
              : "translate-x-1 bg-slate-400 group-hover/switch:bg-slate-300"
          } inline-block h-4 w-4 transform rounded-full  transition-transform duration-200 ease-in-out`}
        />
        {children}
      </button>
      {label && (
        <span
          className={` text-sm/6  text-slate-900 dark:text-slate-200 ${
            isSetting
              ? "flex-grow text-left text-xs uppercase  tracking-widest flex items-center gap-1 text-slate-700 dark:text-slate-300 font-mono"
              : " ml-3"
          }`}
        >
          {label}
        </span>
      )}
    </label>
  );
};
